import { createActionGroup, emptyProps, props } from '@ngrx/store';

export const TopbarActions = createActionGroup({
  source: 'Topbar',
  events: {
    'Load Topbars': emptyProps(),
    
    
  }
});
